import { useDispatch } from "react-redux";
import { STRING_SUB_MENU } from "../../../constants/string";
import { toggleMenuContent } from "../../../store/themeConfigSlice";
import { useEffect, useState } from "react";
import { useFetchData } from "../../../hooks/useFetch";
import { API_BRANDS_ROUTER, ApiConfig } from "../../../services/api-config";
import { showToast } from "../../../components/custom/custom-toast";
import { PAGE_SIZES } from "../../../constants/status";
import { PromotionBrand } from "../../../models/response/promotion-brand";
import { PromotionAssignBrandTable } from "../components/promotion-assign-brand-table";

export const PromotionAssignBrandPage = () => {
  const dispatch = useDispatch();
  dispatch(toggleMenuContent(STRING_SUB_MENU.BRAND_ASSIGN_PROMOTION));

  const [promotionBrands, setPromotionBrands] = useState<PromotionBrand[]>([]);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(PAGE_SIZES[0]);
  const [keySearch, setKeySearch] = useState("");
  const [refresh, setRefresh] = useState(false)

  const { request: getPromotionsCampaign, baseResponse: promotionsCampaignRes, loading: tableLoading } = useFetchData.Get<PromotionBrand[]>({ projectId: ApiConfig.PROJECT_ID.USER_SERVICE });

  useEffect(() => {
    const fetchData = async () => {
      const params = {};
      await getPromotionsCampaign({
        endPoint: API_BRANDS_ROUTER.API_GET_BRAND_PROMOTIONS(),
        data: params,
      });
    };

    fetchData();
  }, [refresh]);

  useEffect(() => {
    if (!promotionsCampaignRes) return;
    if (promotionsCampaignRes?.data && promotionsCampaignRes?.status === 200) {
      setPromotionBrands(promotionsCampaignRes.data);
    } else {
      showToast({
        message: promotionsCampaignRes?.message ?? "Không thể tải danh sách khuyến mãi",
        type: "error",
      });
    }
  }, [promotionsCampaignRes]);


  const handleDataChange = () => {
    setRefresh(!refresh);
  }

  return (
    <div className="flex flex-col gap-3">
      <PromotionAssignBrandTable
        tableLoading={tableLoading}
        data={promotionBrands ?? []}
        keySearch={keySearch}
        setKeySearch={setKeySearch}
        page={page}
        setPage={setPage}
        pageSize={limit}
        setPageSize={setLimit}
        handleDataChange={handleDataChange}
      />
    </div>
  );
};
